/* =====================================================
   Section : Page produit simple — FOG
   Slider images + Quantity + Add to cart AJAX
   ===================================================== */

(function () {
  'use strict';

  /* Libelles : snippets/i18n-js.liquid (window.FOG_I18N, charge avant ce script
     par layout/theme.liquid). Lu a l'appel, jamais en dur. Spec 07. */
  function i18n(cle, vars) {
    return window.FOG_I18N.t(cle, vars);
  }

  /* ---------- Slider ---------- */

  function initSlider(root) {
    var track = root.querySelector('[data-ps-track]');
    var slides = root.querySelectorAll('[data-ps-slide]');
    var dots = root.querySelectorAll('[data-ps-dot]');
    var prev = root.querySelector('[data-ps-prev]');
    var next = root.querySelector('[data-ps-next]');
    var count = slides.length;
    if (count <= 1 || !track) return;

    var current = 0;

    function goTo(i) {
      current = ((i % count) + count) % count;
      track.style.transform = 'translateX(' + (-100 * current) + '%)';
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
      // Expose l'index courant pour la synchro avec la lightbox
      root.setAttribute('data-current-index', current);
      // Met en pause les videos quand on quitte leur slide (no-op si aucune video)
      var vids = track.querySelectorAll('video');
      for (var vi = 0; vi < vids.length; vi++) {
        try { vids[vi].pause(); } catch (e) {}
      }
    }

    // Petite API consommee par la lightbox (resync a la fermeture)
    root.psGoTo = goTo;

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var idx = parseInt(d.getAttribute('data-index'), 10);
        if (!isNaN(idx)) goTo(idx);
      });
    });

    // Swipe touch basique
    var startX = 0;
    var diffX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      diffX = 0;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      diffX = e.touches[0].clientX - startX;
    }, { passive: true });
    track.addEventListener('touchend', function () {
      if (Math.abs(diffX) > 40) {
        if (diffX < 0) goTo(current + 1);
        else goTo(current - 1);
      }
    });

    // Init
    goTo(0);
  }

  /* ---------- Lightbox : agrandissement + zoom ---------- */

  function initLightbox(root) {
    var lb = root.querySelector('[data-ps-lightbox]');
    if (!lb) return;

    // Sources : uniquement les images de galerie reelles (le placeholder n'a pas de data-zoom-src)
    var sources = Array.prototype.slice.call(root.querySelectorAll('.ps-slide__img[data-zoom-src]'));
    if (!sources.length) return;

    var slider = root.querySelector('[data-ps-slider]');
    var stage = lb.querySelector('[data-ps-lb-stage]');
    var img = lb.querySelector('[data-ps-lb-img]');
    var backdrop = lb.querySelector('[data-ps-lb-backdrop]');
    var closeBtn = lb.querySelector('[data-ps-lb-close]');
    var prevBtn = lb.querySelector('[data-ps-lb-prev]');
    var nextBtn = lb.querySelector('[data-ps-lb-next]');
    var counter = lb.querySelector('[data-ps-lb-counter]');

    var ZOOM_CLICK = 2.5;   // niveau cible au clic / double-tap
    var ZOOM_HARD_MAX = 4;  // plafond molette / pinch

    var current = 0;
    var scale = 1;
    var panX = 0;
    var panY = 0;
    var isOpen = false;
    var lastFocus = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setAnim(on) {
      img.classList.toggle('ps-lightbox__img--no-anim', !on);
    }

    function applyTransform() {
      img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
      lb.classList.toggle('is-zoomed', scale > 1.01);
    }

    function clampPan() {
      var baseW = img.offsetWidth;
      var baseH = img.offsetHeight;
      var sw = baseW * scale;
      var sh = baseH * scale;
      var sr = stage.getBoundingClientRect();
      var maxX = Math.max(0, (sw - sr.width) / 2);
      var maxY = Math.max(0, (sh - sr.height) / 2);
      panX = Math.max(-maxX, Math.min(maxX, panX));
      panY = Math.max(-maxY, Math.min(maxY, panY));
    }

    function resetZoom() {
      scale = 1;
      panX = 0;
      panY = 0;
      applyTransform();
    }

    // Plafonne le zoom utile selon la resolution reelle de la source affichee.
    // Calcule a la demande : offsetWidth est alors fiable (image deja mise en page),
    // contrairement a l'instant onload. Floor 1.5 pour qu'un clic zoome toujours un peu ;
    // sur une source basse def, le zoom reste borne pour limiter le flou.
    function maxZoom() {
      var displayed = img.offsetWidth || 1;
      var natural = img.naturalWidth || displayed;
      return Math.max(1.5, Math.min(ZOOM_HARD_MAX, natural / displayed));
    }

    function loadImage(i) {
      var src = sources[i];
      var zoomSrc = src.getAttribute('data-zoom-src') || src.currentSrc || src.src;
      setAnim(false);
      resetZoom();
      // Source unique (pas de srcset) : naturalWidth reflete la resolution reelle,
      // ce qui rend le plafonnement de zoom fiable meme si l'original est petit.
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = zoomSrc;
      img.alt = src.getAttribute('alt') || '';
      updateCounter();
    }

    function updateCounter() {
      if (counter) counter.textContent = (current + 1) + ' / ' + sources.length;
    }

    function goTo(i) {
      current = ((i % sources.length) + sources.length) % sources.length;
      loadImage(current);
    }

    function open(index) {
      current = index || 0;
      lastFocus = document.activeElement;
      lb.hidden = false;
      loadImage(current);
      // force reflow puis transition d'ouverture
      void lb.offsetWidth;
      lb.classList.add('is-open');
      document.documentElement.classList.add('ps-no-scroll');
      isOpen = true;
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('ps-no-scroll');
      // Resync le slider inline sur l'image affichee. current indexe les images
      // seules, le slider toutes les diapositives (videos comprises) : on prend
      // l'index de la diapositive qui porte l'image.
      if (slider && typeof slider.psGoTo === 'function') {
        var slide = sources[current].closest('[data-ps-slide]');
        var slideIndex = slide ? parseInt(slide.getAttribute('data-index'), 10) : NaN;
        slider.psGoTo(isNaN(slideIndex) ? current : slideIndex);
      }

      var finish = function () { lb.hidden = true; img.removeAttribute('src'); };
      if (reduceMotion) {
        finish();
      } else {
        var done = false;
        var onEnd = function () { if (done) return; done = true; lb.removeEventListener('transitionend', onEnd); finish(); };
        lb.addEventListener('transitionend', onEnd);
        setTimeout(onEnd, 320);
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    // Bascule 1x <-> zoom centre sur un point ecran (cx, cy)
    function toggleZoomAt(cx, cy) {
      setAnim(true);
      if (scale > 1.01) {
        resetZoom();
        return;
      }
      var target = Math.min(ZOOM_CLICK, maxZoom());
      if (target <= 1.01) return; // resolution trop faible : pas de zoom utile
      var sr = stage.getBoundingClientRect();
      var centerX = sr.left + sr.width / 2;
      var centerY = sr.top + sr.height / 2;
      var ox = (cx - centerX);
      var oy = (cy - centerY);
      scale = target;
      panX = ox * (1 - target);
      panY = oy * (1 - target);
      clampPan();
      applyTransform();
    }

    // Zoom molette centre sur le curseur
    function zoomAt(cx, cy, factor) {
      var prevScale = scale;
      var next = Math.max(1, Math.min(maxZoom(), scale * factor));
      if (next === prevScale) return;
      var sr = stage.getBoundingClientRect();
      var centerX = sr.left + sr.width / 2;
      var centerY = sr.top + sr.height / 2;
      // point base sous le curseur (independant du scale)
      var baseX = (cx - centerX - panX) / prevScale;
      var baseY = (cy - centerY - panY) / prevScale;
      scale = next;
      panX = (cx - centerX) - baseX * scale;
      panY = (cy - centerY) - baseY * scale;
      if (scale <= 1.001) { scale = 1; panX = 0; panY = 0; }
      clampPan();
      applyTransform();
    }

    /* --- Ouverture depuis la galerie (clic + clavier) --- */
    sources.forEach(function (src, i) {
      src.addEventListener('click', function () { open(i); });
      src.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          open(i);
        }
      });
    });

    /* --- Controles --- */
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', function () { if (scale <= 1.01) close(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { setAnim(false); goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setAnim(false); goTo(current + 1); });

    /* --- Clic / drag desktop sur l'image --- */
    var pointerDown = false;
    var moved = false;
    var startX = 0, startY = 0, startPanX = 0, startPanY = 0;

    img.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // le tactile est gere a part
      pointerDown = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
      startPanX = panX;
      startPanY = panY;
      setAnim(false);
    });
    window.addEventListener('pointermove', function (e) {
      if (!pointerDown || e.pointerType === 'touch') return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
      if (scale > 1.01) {
        panX = startPanX + dx;
        panY = startPanY + dy;
        clampPan();
        applyTransform();
      }
    });
    window.addEventListener('pointerup', function (e) {
      if (!pointerDown || e.pointerType === 'touch') return;
      pointerDown = false;
      if (!moved) toggleZoomAt(e.clientX, e.clientY);
    });

    /* --- Molette desktop --- */
    stage.addEventListener('wheel', function (e) {
      if (!isOpen) return;
      e.preventDefault();
      setAnim(false);
      var factor = e.deltaY < 0 ? 1.12 : 0.89;
      zoomAt(e.clientX, e.clientY, factor);
    }, { passive: false });

    /* --- Tactile : pinch, pan, swipe, double-tap --- */
    var tStartX = 0, tStartY = 0, tPanX = 0, tPanY = 0;
    var pinchStartDist = 0, pinchStartScale = 1;
    var swipeDX = 0;
    var lastTap = 0;
    var touchMode = ''; // 'pan' | 'swipe' | 'pinch'

    function dist(t) {
      var dx = t[0].clientX - t[1].clientX;
      var dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    stage.addEventListener('touchstart', function (e) {
      if (!isOpen) return;
      if (e.touches.length === 2) {
        touchMode = 'pinch';
        pinchStartDist = dist(e.touches);
        pinchStartScale = scale;
        setAnim(false);
      } else if (e.touches.length === 1) {
        tStartX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tPanX = panX;
        tPanY = panY;
        swipeDX = 0;
        touchMode = scale > 1.01 ? 'pan' : 'swipe';
        setAnim(false);
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!isOpen) return;
      if (touchMode === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        var d = dist(e.touches);
        if (pinchStartDist > 0) {
          scale = Math.max(1, Math.min(maxZoom(), pinchStartScale * (d / pinchStartDist)));
          clampPan();
          applyTransform();
        }
      } else if (touchMode === 'pan' && e.touches.length === 1) {
        e.preventDefault();
        panX = tPanX + (e.touches[0].clientX - tStartX);
        panY = tPanY + (e.touches[0].clientY - tStartY);
        clampPan();
        applyTransform();
      } else if (touchMode === 'swipe' && e.touches.length === 1) {
        swipeDX = e.touches[0].clientX - tStartX;
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (!isOpen) return;
      if (touchMode === 'swipe') {
        if (Math.abs(swipeDX) > 40) {
          setAnim(false);
          goTo(swipeDX < 0 ? current + 1 : current - 1);
        } else {
          // detection double-tap (peu de mouvement)
          var now = Date.now();
          if (now - lastTap < 300) {
            var t = (e.changedTouches && e.changedTouches[0]) || {};
            toggleZoomAt(t.clientX || 0, t.clientY || 0);
            lastTap = 0;
          } else {
            lastTap = now;
          }
        }
      } else if (touchMode === 'pinch') {
        if (scale <= 1.01) resetZoom();
      }
      if (e.touches.length === 0) touchMode = '';
    });

    /* --- Clavier global (modal ouverte) ---
       Sur document et non sur la lightbox : un clic de zoom dans l'image (zone non focalisable) renvoie le
       focus sur body, et Echap ne fermait plus (constat du filet de parcours, 2026-10-15). */
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); setAnim(false); goTo(current + 1); return; }
      if (e.key === 'ArrowLeft') { e.preventDefault(); setAnim(false); goTo(current - 1); return; }
      if (e.key === 'Tab') {
        var focusables = [closeBtn, prevBtn, nextBtn].filter(function (el) { return el && el.offsetParent !== null; });
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Re-borne le pan si la fenetre change de taille pendant l'ouverture
    window.addEventListener('resize', function () {
      if (!isOpen) return;
      var mz = maxZoom();
      if (scale > mz) scale = mz;
      clampPan();
      applyTransform();
    });
  }

  /* ---------- Quantity ---------- */

  function initQty(root) {
    var qty = root.querySelector('[data-ps-qty]');
    if (!qty) return;
    var input = qty.querySelector('[data-ps-qty-input]');
    var btns = qty.querySelectorAll('[data-action]');
    if (!input) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.getAttribute('data-action');
        var v = parseInt(input.value, 10) || 1;
        if (action === 'increase') v += 1;
        else if (action === 'decrease') v = Math.max(1, v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Sur change et non sur input : corrige a l'input, effacer le « 1 » le
    // remettait aussitot et taper « 5 » donnait « 15 ».
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
    });
  }

  /* ---------- Add to cart AJAX ---------- */

  function initCartForm(root) {
    var form = root.querySelector('[data-ps-cart-form]');
    if (!form) return;

    // Le form est visible des le rendu serveur (CSS). La classe ne sert plus
    // qu'au filet de parcours (scripts/filet-site/parcours.mjs), qui la lit.
    form.classList.add('ps-buy--ready');

    var errorEl = form.querySelector('[data-ps-cart-error]');
    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    form.addEventListener('submit', function onSubmit(e) {
      e.preventDefault();
      var btn = form.querySelector('.ps-cta');
      if (!btn || btn.disabled) return;

      // Entree dans un champ vide : change ne l'a pas forcement corrige
      var qtyInput = form.querySelector('[data-ps-qty-input]');
      if (qtyInput && !(parseInt(qtyInput.value, 10) >= 1)) qtyInput.value = 1;

      if (errorEl) errorEl.hidden = true;
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.textContent = i18n('products.simple.adding');

      var data = new FormData(form);

      fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : window.FOG_ROUTES.url('cart/add.js'), {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (res) {
          if (res.ok) {
            // Ajout fait : une reponse illisible ne doit pas renvoyer le form
            // (second ajout), on considere l'ajout reussi.
            return res.json().catch(function () { return {}; }).then(function () {
              btn.textContent = i18n('products.simple.added');
              document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { source: 'product-simple' } }));
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = originalLabel;
              }, 1500);
            });
          }
          // Refus de Shopify (422 stock, 429...) : sa description, deja dans la
          // langue de la boutique, ou le message generique du theme.
          return res.json().catch(function () { return {}; }).then(function (body) {
            showError((body && body.description) || i18n('products.configurable.add_error'));
            btn.disabled = false;
            btn.textContent = originalLabel;
          });
        }, function () {
          // Echec reseau de fetch, et lui seul : on retombe sur l'envoi natif du
          // formulaire. (arguments.callee levait une TypeError en mode strict :
          // ce repli n'avait jamais fonctionne, le bouton restait fige.)
          form.removeEventListener('submit', onSubmit);
          form.submit();
        });
    });
  }

  /* ---------- Cross-sell ----------
     initRecommendations() a ete supprimee le 31 juillet 2026 : elle ne s'est
     jamais executee (sortie immediate des que la grille avait des enfants, ce
     qui etait toujours le cas) et son URL partait avec un section_id vide, donc
     inexploitable. Les suggestions sont rendues cote serveur par
     snippets/product-related-suggestions.liquid. */

  /* ---------- Richtext : description produit redesign ---------- */

  function initRichtext(root) {
    var NBSP = String.fromCharCode(160);
    var BULLET_RE = /^[•·‣⁃∙–—\-]/;

    var rts = root.querySelectorAll('.ps-richtext');

    function esc(s) {
      return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function norm(s) {
      return s.split(NBSP).join(' ').replace(/\s+/g, ' ').trim();
    }

    rts.forEach(function (rt) {
      var children = [];
      (function collect(parent) {
        Array.from(parent.childNodes).forEach(function (node) {
          if (node.nodeType !== 1) return;
          var tag = node.tagName;
          if (tag === 'P' || tag === 'H6' || tag === 'H5' || tag === 'H4' || tag === 'H3' || tag === 'H2' || tag === 'H1' || tag === 'UL' || tag === 'OL' || tag === 'HR') {
            children.push(node);
          } else if (tag === 'DIV' || tag === 'SECTION' || tag === 'ARTICLE') {
            collect(node);
          }
        });
      })(rt);
      var specGroups = [];
      var currentGroup = [];
      var foundIntro = false;

      function flush() {
        if (currentGroup.length > 0) {
          specGroups.push(currentGroup.slice());
          currentGroup = [];
        }
      }

      children.forEach(function (el) {
        if (el.tagName === 'H6') {
          flush();
          foundIntro = true;
          return;
        }

        if (el.tagName !== 'P') { flush(); return; }

        var b = el.querySelector('b, strong');
        if (!b) { flush(); return; }

        var pText = norm(el.textContent);
        var bText = norm(b.textContent);

        var bClean = bText.replace(/[\s:]+$/, '');
        var pClean = pText.replace(/[\s:]+$/, '');
        if (pClean === bClean && bClean.length > 0 && pText.length < 80) {
          flush();
          if (!foundIntro) {
            el.classList.add('ps-intro-title');
            foundIntro = true;
          } else {
            el.classList.add('ps-section-header');
          }
          return;
        }

        if (BULLET_RE.test(pText.replace(/^\s+/, ''))) { flush(); return; }

        var label = bText.replace(/:$/, '').trim();
        var boldPos = pText.indexOf(bText);
        if (boldPos === -1) { flush(); return; }

        var afterBold = pText.substring(boldPos + bText.length).trim();
        var value = '';

        if (afterBold.charAt(0) === ':') {
          value = afterBold.substring(1).trim();
        } else if (bText.charAt(bText.length - 1) === ':') {
          value = afterBold;
        }

        if (label.length > 0 && label.length < 50 && value.length > 0 && value.length < 100) {
          el.classList.add('ps-spec-line');
          el.innerHTML =
            '<span class="ps-spec-label">' + esc(label) + '</span>' +
            '<span class="ps-spec-value">' + esc(value) + '</span>';
          currentGroup.push(el);
          return;
        }

        flush();
      });

      flush();

      specGroups.forEach(function (group) {
        if (group.length === 0) return;
        var wrapper = document.createElement('div');
        wrapper.className = 'ps-specs-grid';
        group[0].parentNode.insertBefore(wrapper, group[0]);
        group.forEach(function (el) { wrapper.appendChild(el); });
      });
    });
  }

  /* ---------- SparkLayer B2B : widget PDP (prix + CTA pro) ----------
     Le form B2C (.ps-buy) n'est rendu par Liquid QUE pour un compte non-b2b
     (masquage cote serveur, cf. product-simple-inline.liquid) : pour un
     compte b2b, il n'existe simplement pas dans le DOM, donc aucun risque
     qu'un fallback JS le rende visible. Ce bloc ne gere que l'affichage
     progressif du widget spark-pdp sur la zone [data-spark-pdp], meme
     logique (poll shadowRoot + detection d'un vrai prix) que
     assets/b2b-spark-cards.js pour la carte collection. */

  function initSparkPdp(root) {
    var zone = root.querySelector('[data-spark-pdp]');
    if (!zone) return; // compte non-b2b : pas de zone B2B a hydrater

    var spark = zone.querySelector('spark-pdp');
    if (!spark) { zone.setAttribute('data-spark-state', 'empty'); return; }

    var PRICE_RE = /[€$£]|\d+[.,]\d{2}|CHF|EUR/;
    var PRICE_TOKEN_RE = /(?:(?:CHF|EUR)\s*)?(?:[€$£]\s*)?\d(?:[\d\s'’.,]*\d)?(?:[.,]\d{2})?\s*(?:CHF|EUR|€|\$|£)?/gi;
    /* Etat « non vendable » du widget, reconnu a son texte (aucun attribut ne le
       distingue de la rupture de stock, verifie dans le bundle 4.3.9). Le texte suit la
       langue de SparkLayer : libelle pdp.messaging.un-sellable de ses fichiers fr, de, it
       et es (« Indisponible », « Nicht verfügbar », « Non Disponibile », « No disponible »,
       releves le 15/10/2026), plus les termes anglais et « épuis » d'origine. Le francais
       reste reconnu a l'identique. Meme liste dans b2b-spark-cards.js. */
    var UNAVAILABLE_RE = /indisponible|unavailable|out of stock|épuis|nicht verfügbar|non disponibile|no disponible/i;
    var POLL_MS = 250;
    /* ~15 s avant repli, aligne sur b2b-spark-cards.js : a froid, le widget met
       jusqu'a 6,8 s a afficher son prix (mesure du 24 septembre 2026), et 6 s
       figeaient parfois « Tarif sur demande » a tort. */
    var MAX_TRIES = 60;

    function parsePriceCents(token) {
      if (!token) return null;
      var raw = String(token);
      var hasCurrency = /[€$£]|CHF|EUR/i.test(raw);
      var hasDecimals = /[.,]\d{2}(?!\d)/.test(raw);
      if (!hasCurrency && !hasDecimals) return null;

      var clean = raw.replace(/[^\d.,]/g, '');
      if (!clean) return null;

      var lastComma = clean.lastIndexOf(',');
      var lastDot = clean.lastIndexOf('.');
      var decimalIndex = Math.max(lastComma, lastDot);
      var cents = '00';
      var units = clean;

      if (decimalIndex > -1 && clean.length - decimalIndex - 1 === 2) {
        cents = clean.slice(decimalIndex + 1);
        units = clean.slice(0, decimalIndex);
      }

      units = units.replace(/[^\d]/g, '');
      if (!units) return null;
      return (parseInt(units, 10) * 100) + parseInt(cents, 10);
    }

    function extractPrice(text, retailCents) {
      var matches = String(text || '').match(PRICE_TOKEN_RE) || [];
      var prices = matches.map(function (token) {
        return { token: token.replace(/\s+/g, ' ').trim(), cents: parsePriceCents(token) };
      }).filter(function (item) {
        return item.cents && item.cents > 0;
      });
      if (!prices.length) return null;
      if (retailCents > 0) {
        for (var i = 0; i < prices.length; i++) {
          if (prices[i].cents <= retailCents) return prices[i];
        }
      }
      return prices[0];
    }

    /* Devise portee par le token de prix SparkLayer ('825,00 CHF', '€1.166,00'...).
       Sert a ne jamais comparer un prix public et un tarif pro exprimes dans deux
       devises differentes (pourcentage faux). La devise de presentation est en
       principe deja alignee sur la price list du client par
       snippets/b2b-market-lock.liquid : ce controle est le filet de securite. */
    function detectCurrency(token) {
      var raw = String(token || '').toUpperCase();
      if (raw.indexOf('CHF') > -1) return 'CHF';
      if (raw.indexOf('EUR') > -1 || raw.indexOf('€') > -1) return 'EUR';
      if (raw.indexOf('£') > -1) return 'GBP';
      if (raw.indexOf('$') > -1) return 'USD';
      return '';
    }

    /* Texte RENDU du widget, sans le CSS injecte dans son shadow root
       (meme piege que b2b-spark-cards.js : « letter-spacing: 0.01em » lu
       comme un prix de CHF 0.01, 29 septembre 2026). */
    var NON_TEXT_RE = /^(STYLE|SCRIPT|TEMPLATE|NOSCRIPT)$/;
    function visibleText(root) {
      if (!root) return '';
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var out = '';
      var node;
      while ((node = walker.nextNode())) {
        var parent = node.parentNode;
        if (parent && parent.nodeType === 1 && NON_TEXT_RE.test(parent.nodeName)) continue;
        out += node.nodeValue + ' ';
      }
      return out;
    }

    function syncB2bSavings(shadowRoot) {
      var retailCents = parseInt(zone.getAttribute('data-retail-price') || '0', 10);
      var retailCurrency = (zone.getAttribute('data-retail-currency') || '').toUpperCase();
      var fallbackCurrency = (zone.getAttribute('data-b2b-currency') || '').toUpperCase();
      var price = extractPrice(visibleText(shadowRoot), retailCents);
      var priceEl = zone.querySelector('[data-b2b-pro-amount]');
      var proWrap = zone.querySelector('[data-b2b-pro]');
      var retailEl = zone.querySelector('[data-b2b-retail]');
      var discountEl = zone.querySelector('[data-b2b-discount]');

      var proCurrency = (price && detectCurrency(price.token)) || fallbackCurrency;

      /* Le montant n'est PAS recopie tel que SparkLayer l'ecrit (« 29,00 CHF ») :
         il est reecrit par window.FOG_MONEY, dans la meme forme que tous les
         autres prix du site (« CHF 29.00 »). Cf. assets/money-format.js. */
      if (priceEl && price) {
        priceEl.textContent = window.FOG_MONEY ? window.FOG_MONEY.format(price.cents, proCurrency) : price.token;
        if (proWrap) proWrap.hidden = false;
      }
      var sameCurrency = !retailCurrency || !proCurrency || retailCurrency === proCurrency;

      /* Second montant TTC (Suisse). Il derive du MEME montant que celui qui vient
         d'etre affiche : si un jour le parsing du widget se trompait, les deux
         montants se tromperaient ensemble plutot que de se contredire a l'ecran.
         Il est ecrit par window.FOG_MONEY, comme le montant HT. Indicatif : le tunnel de commande reste en HT.
         Cf. assets/price-ttc.js.

         Meme garde-fou de devise que le comparatif public : au premier chargement
         qui suit un changement de compte, le widget sert encore les prix de la
         price list precedente (mesure du 13 septembre 2026, un rechargement suffit
         a corriger). Appliquer la TVA suisse a un montant qui n'est pas dans la
         devise du marche produirait un « TTC » faux. */
      if (window.FOG_TTC && proWrap) {
        window.FOG_TTC.apply(proWrap, sameCurrency ? (price && price.cents) : null, proCurrency);
      }

      if (!sameCurrency) {
        if (retailEl) retailEl.hidden = true;
        zone.removeAttribute('data-savings');
        console.warn('[FOG B2B] prix public masque, devises differentes :', retailCurrency, 'vs', proCurrency);
        return;
      }

      /* Remise HT contre HT (prix public et tarif pro sont hors taxes).
         data-savings commande le prix public barre et le badge (cf.
         section-product-simple.css) : sans economie reelle, on ne barre rien.
         Badge « −43 % » : signe moins typographique, espace insecable. */
      var discount = (price && retailCents > 0 && price.cents < retailCents)
        ? Math.round(((retailCents - price.cents) / retailCents) * 100)
        : 0;
      if (discount > 0) {
        zone.setAttribute('data-savings', 'true');
        if (discountEl) {
          (discountEl.querySelector('[data-b2b-discount-value]') || discountEl).textContent = i18n('products.b2b.discount_badge', { percent: discount });
          discountEl.hidden = false;
        }
      } else {
        zone.removeAttribute('data-savings');
      }
    }

    function cleanSparkVisiblePrices(shadowRoot) {
      if (!shadowRoot || shadowRoot.querySelector('[data-fog-b2b-clean]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-fog-b2b-clean', 'true');
      style.textContent = [
        '[class*="price" i],',
        '[class*="pricing" i],',
        '[class*="rrp" i],',
        '[part*="price" i] { display: none !important; }'
      ].join('\n');
      shadowRoot.appendChild(style);
    }

    function cleanSparkButtonLabels(shadowRoot) {
      if (!shadowRoot) return;
      var walker = document.createTreeWalker(shadowRoot, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var cleaned = node.nodeValue.replace(/\s*\([^)]*(?:CHF|EUR|€|\$|£)[^)]*\)/gi, '');
        if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
      }
    }

    function cleanSparkWidget(shadowRoot) {
      cleanSparkVisiblePrices(shadowRoot);
      cleanSparkButtonLabels(shadowRoot);
      setTimeout(function () { cleanSparkButtonLabels(shadowRoot); }, 400);
      setTimeout(function () { cleanSparkButtonLabels(shadowRoot); }, 1200);
      if (!shadowRoot.__fogB2bButtonObserver) {
        shadowRoot.__fogB2bButtonObserver = new MutationObserver(function () {
          cleanSparkButtonLabels(shadowRoot);
        });
        shadowRoot.__fogB2bButtonObserver.observe(shadowRoot, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }

    function hasRealPrice(shadowRoot) {
      if (!shadowRoot) return false;
      var t = visibleText(shadowRoot).replace(/\s+/g, ' ');
      if (UNAVAILABLE_RE.test(t)) return false;
      return PRICE_RE.test(t);
    }

    /* Aligne la bande de reassurance sur la largeur du widget, une fois l'etat
       final atteint (prix affiche ou repli). */
    function alignReassurance() {
      setTimeout(function () {
        var w = spark.offsetWidth;
        var r = root.querySelector('.ps-reassurance');
        if (r && w > 0) {
          r.style.width = w + 'px';
          r.style.maxWidth = w + 'px';
        }
      }, 800);
    }

    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var sr = spark.shadowRoot;
      var hydrated = sr && visibleText(sr).trim().length > 0;

      /* Le widget s'hydrate en deux temps : d'abord un squelette sans montant,
         puis le prix. On attend donc le prix lui-meme, pas seulement du contenu,
         sinon on fige "Tarif sur demande" alors que le tarif existe. */
      if (hydrated && hasRealPrice(sr)) {
        clearInterval(iv);
        syncB2bSavings(sr);
        cleanSparkWidget(sr);
        zone.setAttribute('data-spark-state', 'priced');
        alignReassurance();
      } else if (tries >= MAX_TRIES) {
        clearInterval(iv);
        zone.setAttribute('data-spark-state', hydrated ? 'empty' : 'timeout');
        alignReassurance();
      }
    }, POLL_MS);
  }

  /* ---------- Init ---------- */

  function init() {
    document.querySelectorAll('[data-section-type="product-simple"]').forEach(function (root) {
      var slider = root.querySelector('[data-ps-slider]');
      if (slider) initSlider(slider);
      initQty(root);
      initCartForm(root);
      initSparkPdp(root);
      initRichtext(root);
      initLightbox(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
